export const formatNumber = (num?: number | string | unknown, format?: string): string | number | undefined => {
  
  if (num === 0 || num === undefined || !num) return '0'

  let numToUse = num
  
  if (typeof numToUse === 'string') numToUse = Number(numToUse)

  if (!numToUse || typeof numToUse !== 'number') return 
  if (numToUse < 10) {
    const [l,r] = String(numToUse.toFixed(1)).split('.').map(Number)
    return `${l || ``}${r ? `.${r}` : ''}`.trim()
  }
  numToUse = Math.round(numToUse as number)
  
  if (typeof numToUse === 'number') {
    if (numToUse > 999999) {
      numToUse = `${(numToUse / 1000000).toFixed(1)}M`.replace(/,/g, '.');
      //else numToUse = `${String(numToUse).slice(0, -5)}M`.replace(/,/g, '.');
    } else if (numToUse > 999) {
      numToUse = `${(numToUse / 1000).toFixed(1)}K`;
      //else numToUse = `${String(numToUse).slice(0, -3)}K`;
    }
  }
 
  return String(numToUse).split('.0').join('')
};

/**
 * Adds commas to a number for better readability
 * @param num - The number to format (can be number or string)
 * @returns The number with commas (e.g., 1000 -> "1,000", 1000000 -> "1,000,000")
 */
export const addCommasToNumber = (num: number | string): string => {
  if (num === null || num === undefined) return '0';
  
  const numStr = String(num);
  const parts = numStr.split('.');
  const integerPart = parts[0];
  const decimalPart = parts[1];
  
  // Add commas to integer part using regex
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  // Return with decimal part if it exists
  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
};